import { useAppTranslation } from "@/utils";
import { InstallmentStatusFilterStatus } from "@payping/api/app/api/bnplConsumerTypes";
import type { InstallmentResponse } from "@payping/api/app/api/bnplConsumerTypes";
import { bnplConsumerApis } from "@payping/api";
import { Alert, Divider, Flex, useMessagedAsync } from "@payping/web-components";
import { useState } from "react";
import OrderDetailsInstallmentCard from "@/pages/Home/OrderDetails/InstallmentCard";
import { moment } from "@payping/utils/dateUtils";
import OrderDetailsPayInstallment from "@/pages/Home/OrderDetails/PayInstallment";
import Loading from "@/pages/loading";
import { PPFullColorLogoFa } from "@/core/utils";

const DelayedInstallmentLimit = () => {
  const { t } = useAppTranslation();
  const [payInstallmentModal, setPayInstallmentModal] = useState<{ data?: InstallmentResponse; show: boolean }>({
    data: undefined,
    show: false,
  });

  const installmentsState = useMessagedAsync(
    () => bnplConsumerApis.installmentsList(undefined, undefined, InstallmentStatusFilterStatus.Delayed),
    [],
    {
      success: false,
      error: true,
    },
  );

  const handleOpenPayInstallmentModal = (data: InstallmentResponse) => {
    setPayInstallmentModal({ data, show: true });
  };

  const handleClosePayInstallmentModal = () => {
    setPayInstallmentModal({ data: undefined, show: false });
  };

  const installmentsList = installmentsState.value?.installments || [];

  if (installmentsState.loading) {
    return <Loading />;
  }

  return (
    <Flex className="tw:h-full" vertical>
      <Flex className="tw:w-full tw:p-5!" align="center">
        <img src={PPFullColorLogoFa} width={60} height={24} />
      </Flex>
      <Divider className="tw:m-0!" />

      <Flex vertical className="tw:h-full tw:w-full tw:p-3!" gap="middle">
        <Alert
          title={null}
          description={
            <Flex vertical gap={"small"}>
              <span>{t("pay.delayedInstallmentLimitTitle")}</span>
              <span>{t("pay.delayedInstallmentLimitContent")}</span>
            </Flex>
          }
          type="warning"
          showIcon
        />

        {installmentsList.map((item, index) => (
          <OrderDetailsInstallmentCard
            installmentNumber={item?.number ?? 0}
            amount={item.installmentFinalAmount ?? 0}
            key={item.installmentCode || index}
            dueDate={moment(item.dueDate) ?? moment(new Date())}
            handlePay={() => {
              handleOpenPayInstallmentModal(item);
            }}
            penaltyAmount={item.delayPenaltyAmount ?? 0}
            isPayAble={item.isPayable}
            installmentStatus={item.installmentStatus}
          />
        ))}
      </Flex>

      {payInstallmentModal.show && payInstallmentModal.data ? (
        <OrderDetailsPayInstallment
          data={payInstallmentModal.data}
          onClose={handleClosePayInstallmentModal}
          open={payInstallmentModal.show}
        />
      ) : null}
    </Flex>
  );
};

export default DelayedInstallmentLimit;
